<template>
    <img src="/images/home-logo.png">
</template>
